import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { FaCheck, FaPlus, FaRulerHorizontal } from 'react-icons/fa';

import { useCartContext } from '../../context/cart_context';

import AmountButtons from '../AmountButtons/';

import Wrapper from './styles';

import { useUserContext } from '../../context/user_context';

import axios from 'axios';

import { toast } from 'react-toastify';
import { FaShareAltSquare } from 'react-icons/fa';
import { formatPrice } from '../../utils/helpers';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from '@chakra-ui/react';
import { TiTick } from 'react-icons/ti';

const AddToCart = ({ product, sizes }) => {
  const { id } = product;

  const colors = product?.colors
    ? product?.colors?.reduce((acc, colorObj) => {
        acc.push(colorObj?.color[1]);

        return acc;
      }, [])
    : [];

  const [stock, setStock] = useState({});

  const { handlecartButton, setMainColor } = useCartContext();

  const [mainColor, setMainColorState] = useState(colors[0] || '');
  const [mainSize, setMainSize] = useState();

  const [amount, setAmount] = useState(1);

  const [wishlistButtonText, setWishlistButtonText] = useState('');

  const [cartButtonText, setCartButtonText] = useState('Add to cart');
  const { currentUser } = useUserContext();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [productPrice, setProductPrice] = useState();
  const [productDiscountPrice, setProductDiscountPrice] = useState();
  const [productMrp, setProductMrp] = useState();

  const {
    isOpen: isOpenSizeChartModal,
    onOpen: onOpenSizeChartModal,
    onClose: onCloseSizeChartModal,
  } = useDisclosure();

  const [code, setCode] = useState(null);

  const updateMainColor = (color) => {
    setMainColorState(color);
    setMainColor(color); // Update context
  };

  useEffect(() => {
    setProductPrice(product.price);
    setProductDiscountPrice(product.discountPrice);
    setProductMrp(Number(product.subPrice) + Number(product.taxPrice));
  }, [mainColor]);

 
  const checkCartStatus = async () => {
    let userid = currentUser?.id;

    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/addtocart/${userid}`
      );

      const array = response.data.data;

      const isPresent = array && array.some((order) => order.id === id);

      if (isPresent) {
        setCartButtonText('Remove from cart');
      } else {
        setCartButtonText('Add to Cart');
      }
    }
  };

  useEffect(() => {
    if(id && currentUser)
    checkCartStatus();
  }, [id]);

  const handleCartButtonClick = async () => {
   if(currentUser){
     await handlecartButton(
       product.id,
       amount,
       currentUser,
       mainSize,
       setCartButtonText,
       onOpen,
       code,
       product.bestOffers,
       product.taxPrice,
       product.weight,
       productDiscountPrice,
       Number(productPrice),
       Number(productMrp),
       product.quantity
     );
   }
   else{
   onOpen()
   }
    checkCartStatus();
  };

  const increase = () => {
    setAmount((oldAmount) => {
      let tempAmount = oldAmount + 1;
      if (tempAmount > product.quantity) {
        tempAmount = oldAmount;
        toast.error(`Only ${product.quantity} products available`);
      }
      
      return tempAmount;
    });
  };

  const decrease = () => {
    setAmount((oldAmount) => {
      let tempAmount = oldAmount - 1;
      if (tempAmount < 1) {
        tempAmount = 1;
      }
      return tempAmount;
    });
  };
  return (
    <div className='w-full flex flex-col justify-center items-start gap-2'>
      <div className='flex flex-wrap justify-start items-center gap-2'>
        <h5 className='font-medium text-lg text-black md:text-[25px] md:font-semibold'>
          {formatPrice(product.subPrice)}{' '}
          <span className='text-sm font-normal'>
            (Exclusive of tax prices, gst is 3%)
          </span>
        </h5>
        {product.showDiscount && productMrp && (
          <span className='text-gray-500 line-through text-sm'>
            {formatPrice(productMrp.toFixed(2))}
          </span>
        )}

        {product.showDiscount &&
          (productDiscountPrice ? (
            <span className='text-red-500 text-sm'>
              ( {formatPrice(productDiscountPrice)} off)
            </span>
          ) : (
            <span className='text-orange-500 text-sm'>
              ({formatPrice((productMrp - productPrice).toFixed(0))} off)
            </span>
          ))}
      </div>
      <p
        className={`${
          product.quantity >= 1 ? ' text-green-600' : 'text-red-500'
        } text-sm ml-2 flex gap-3 items-center justify-center`}
      >
        <span
          className={`h-4 w-4 border ${
            product.quantity >= 1
              ? 'border border-green-600'
              : 'border text-red-500'
          }   rounded-full object-contain`}
        >
          <TiTick />
        </span>
        {product.quantity >= 1 ? 'In stock — ready to ship' : 'Out of stock'}
      </p>

      <div className='flex flex-row items-center gap-4 mt-2 w-full'>
        <AmountButtons
          amount={amount}
          increase={increase}
          decrease={decrease}
        />
        <div>
          <button
            className='bg-[#D3A143] text-white px-6 py-3 rounded-lg shadow hover:bg-[#c79338] transition-all disabled:bg-gray-300 flex-1 text-center'
            onClick={handleCartButtonClick}
            disabled={product.quantity <= 0}
          >
            {stock[mainSize] === 0 ? 'Out of Stock' : cartButtonText}
          </button>
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Please Login</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>Please login to add items to your cart and wishlist.</p>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button>
            <Link to='/login'>
              <Button variant='ghost'>Login</Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default AddToCart;
